import type { ReactNode } from 'react'
import React from 'react'
import { ModalBox } from '../../partials/ModalBox'
import * as S from './styled'

type Props = {
  title: string
  items: { label: string; content: ReactNode }[]
  onClose: () => void
}

export const SummaryModal = ({ title, items, onClose }: Props) => {
  return (
    <ModalBox title={title} onClose={onClose}>
      {items.map(({ label, content }) => (
        <S.Item>
          <S.ItemLabel>{label}</S.ItemLabel>
          <S.ItemContent>{content}</S.ItemContent>
        </S.Item>
      ))}
    </ModalBox>
  )
}
